import React from "react";
import { Home, Microscope, Activity, FileText, HelpCircle } from "lucide-react";

export const ICON_CLASS = "size-4";

export interface NavItemConfig {
  key: string;
  labelKey: string;
  defaultLabel: string;
  icon: React.ReactNode;
  path: string;
}

export const ALL_NAV_ITEMS: Record<string, NavItemConfig> = {
  home: {
    key: "home",
    labelKey: "nav.home",
    defaultLabel: "首页",
    icon: <Home className={ICON_CLASS} />,
    path: "/",
  },
  assessments: {
    key: "assessments",
    labelKey: "nav.assessmentsShort",
    defaultLabel: "识别",
    icon: <Microscope className={ICON_CLASS} />,
    path: "/assessments",
  },
  /*
  consultations: {
    key: "consultations",
    labelKey: "nav.consultations",
    defaultLabel: "咨询",
    icon: <Activity className={ICON_CLASS} />,
    path: "/consultations",
  },
  */
};

export const ENCYCLOPEDIA_MENU: NavItemConfig[] = [
  /*
  {
    key: "encyclopedia_articles",
    labelKey: "nav.encyclopediaArticles",
    defaultLabel: "文章",
    icon: <FileText className={ICON_CLASS} />,
    path: "/encyclopedia/goldfish/articles",
  },
  {
    key: "encyclopedia_faqs",
    labelKey: "nav.encyclopediaQas",
    defaultLabel: "问答",
    icon: <HelpCircle className={ICON_CLASS} />,
    path: "/encyclopedia/goldfish/qas",
  },
  */
];
